import React from "react"
import PropTypes from "prop-types"

import ContextProvider from "../provider/ContextProvider"

import Header from "./header"
import Footer from "./footer"
import NewsletterSignup from "./newsletterSignup"
import InHandsEstimator from "./inHandsEstimator"

const Layout = ({ children, inHands }) => {
  return (
    <ContextProvider>
      <Header />
      <main>{children}</main>
      {inHands !== false && (
        <section className="has-background-white-ter">
          <InHandsEstimator />
        </section>
      )}
      <NewsletterSignup />
      <Footer />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
